import { zodResolver } from '@hookform/resolvers/zod';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import * as z from 'zod';

import { DialogHeader, DialogTitle } from '@/components/core/dialog';
import { View } from '@/components/data-table/views/types';
import { useWhileDialogOpen } from '@/components/dialog-with-context';
import { FormDialogContent } from '@/components/forms/form-dialog';
import { TextFormField } from '@/components/forms/text-form-field';
import { Result } from '@/shared/helpers/Result';

type Props = {
  view?: View;
  onSubmit: (name: string) => Promise<Result>;
};

const schema = z.object({
  name: z.string().nonempty(),
});
export function ViewNameDialogContent({ onSubmit, view: viewProp }: Props) {
  const view = useWhileDialogOpen(viewProp);
  const form = useForm({
    defaultValues: { name: view?.name ?? '' },
    resolver: zodResolver(schema),
  });

  useEffect(() => {
    form.reset({ name: view?.name ?? '' });
    // eslint-disable-next-line react-hooks/exhaustive-deps -- only when view changes
  }, [view]);

  return (
    <FormDialogContent form={form} onSubmit={(data) => onSubmit(data.name)}>
      <DialogHeader>
        <DialogTitle>{view ? 'Rename view' : 'Add view'}</DialogTitle>
      </DialogHeader>
      <TextFormField control={form.control} name="name" aria-label="Name" placeholder="View name" />
    </FormDialogContent>
  );
}
